import { atom } from "jotai";

export type State = null | {
  agendaEvent: string;
  agendaEventDate: string;
};

export const plusNewsAgendaAtom = atom<State>(null);
